<template>
  <div class="pageContent" style="position: absolute;">
    <!--顶部一条-->
    <pageTitle title='我的订单' :showBack = 'false'></pageTitle>

    <div style="width:100% ; " align="center">
      <mu-tabs :value="activeTab" @change="handleTabChange">
        <mu-tab value="tab1" title="当前订单" />
        <mu-tab value="tab2" title="历史订单" />
        <!-- <mu-tab value="tab3" title="K币换房" /> -->
      </mu-tabs>

      <!--第一页 - 当前订单页-->
      <div v-if="activeTab === 'tab1'" v-on:touchmove="loadPage(1)" v-on:touchend="loadEnd(1)">
        <!--下拉刷新-->
        <mu-refresh-control :refreshing="refreshing[0]" :trigger="trigger[0]" @refresh="refresh(1)" v-if=" this.loadMsg[0] !=''  " />

        <!--订单列表-->
        <orderList :CardKindDiplay='g_UserInfo.Card_Kind_Diplay' :orderList='List[0]' v-on:cancelOrder="CancelOrder" v-on:payMoney="goPayMoney" v-on:goDetail="goDetail"/>
        <!--列表尾巴-->
        <loadListTail :showExtend='true' @btnHandler='goHome' mainTitle='您还没有订单哦，快去逛逛吧！' :extendBtn='true' mainIcon='noOrder' subTitle="优惠活动" subIcon='activity' :noMore='loadMsg[0] == "没有更多记录"' :isLoading='loadState[0]' :overZero='List[0].length > 0' :showBtn='true'  />

        <!--加载状态语句 + 图标-->
        <div class="loading" v-if="loadState[0]">
          <img src="../../../static/LoadingWhite.gif" style=" width:1.2rem ; margin-top:2.1rem" v-if="this.loadMsg[0] != '加载中...'" />
          <img src="../../../static/LoadingWhite.gif" style=" width:1.2rem ; " v-if="this.loadMsg[0] == '加载中...'" />
        </div>
        
        <!--全部加载完毕-->
        <div style='height:66px;'></div>
      </div>

      <!--第二页-->
      <div v-if="activeTab === 'tab2'" v-on:touchmove="loadPage(2)" v-on:touchend="loadEnd(2)">

        <mu-refresh-control :refreshing="refreshing[1]" :trigger="trigger[1]" @refresh="refresh(2)" v-if=" this.loadMsg[1] !=''  " />
        <orderList :orderList='List[1]' v-on:deleteOrder="DeleteOrder" v-on:goDetail="goDetail" :showCurrent='false'/>
        <!--列表尾巴-->
        <loadListTail mainTitle='您暂无历史订单' mainIcon='noOrder' :noMore='loadMsg[1] == "没有更多记录"' :isLoading='loadState[1]' :overZero='List[1].length > 0'  />
        <!--加载图标-->
        <div class="loading" v-if="loadState[1]">
          <img src="../../../static/LoadingWhite.gif" style=" width:1.2rem ; margin-top: 2.1rem" v-if="this.loadMsg[1] != '加载中...'" />
          <img src="../../../static/LoadingWhite.gif" style=" width:1.2rem ; " v-if="this.loadMsg[1] == '加载中...'" />
        </div>
      </div>

      <!--第三页-->
      <div v-if="activeTab === 'tab3'" v-on:touchmove="loadPage(2)" v-on:touchend="loadEnd(2)">
        <mu-refresh-control :refreshing="refreshing[2]" :trigger="trigger[2]" @refresh="refresh(3)" v-if=" this.loadMsg[2] !=''  " />
        <orderList :orderList='List[2]' v-on:cancelOrder="CancelOrder" v-on:deleteOrder="DeleteOrder" v-on:goDetail="goDetail"/>
        <!--列表尾巴-->
        <loadListTail mainTitle='您暂无K币订单' mainIcon='noOrder' :noMore='loadMsg[2] == "没有更多记录"' :isLoading='loadState[2]' :overZero='List[2].length > 0'  />
        <!--加载图标-->
        <div class="loading" v-if="loadState[2]">
          <img src="../../../static/LoadingWhite.gif" style=" width:1.2rem ; margin-top:2.1rem" v-if="this.loadMsg[2] != '加载中...'" />
          <img src="../../../static/LoadingWhite.gif" style=" width:1.2rem ; " v-if="this.loadMsg[2] == '加载中...'" />
        </div>
      </div>

    </div>

    <!--弹出框 选择是否   单纯用在取消-->
    <pop :display='popDisplay' @closeHandler='closePop' @okHandler='closeYES' title='温馨提示' :msg='popMsg' :onlyOk='popOnlyOk'/> 
    <!--弹出框-->
    <mu-toast v-if="toast" v-bind:message="TellUser" @close="hideToast" id="alertline" />
  </div>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex'
import api from '../../api'
import loadListTail from '../../components/loadListTail'
import orderList from '../../components/orderList'
import pop from '../../components/pop'

export default {
  mounted() {
    this.trigger[0] = this.$el
    this.trigger[1] = this.$el
    this.trigger[2] = this.$el
  },

  computed: {
    ...mapGetters([
      'g_UserInfo', 'g_PayOrder'
    ]),
  },

  data() {
    return {
      cardno: '',
      activeTab: 'tab1',


      refreshing: [false, false, false],
      trigger: [null, null, null],


      // 弹出层
      TellUser: '',
      toast: false,
      // 弹出标签 选择是否
      popDisplay: false,
      popMsg:'',
      popOnlyOk:false,
      
      List: [[], [], []],


      OrderPage: [1, 1, 1],

      loadMsg: ['', '', ''],
      loadState: [true, true, true],
      toast: false,

      // 删除或者取消
      ParentResvNo: '',
      Cancel_Delete: '',
    }
  },

  components: {
    loadListTail,orderList,pop
  },

  created(){
    // 刷新之后，需要重置更新
      var UserInfo = this.g_UserInfo
      UserInfo.OrderRefresh1 = true
      UserInfo.OrderRefresh2 = true
      UserInfo.OrderRefresh3 = true
      this.setG_UserInfo(UserInfo)
  },

  activated() {
    //this.activeTab = 'tab1';

    if( this.List[0].length == 0 ){

      var UserInfo = this.g_UserInfo;
      UserInfo.OrderRefresh1 = true;
      this.setG_UserInfo(UserInfo);

    }

    var UserInfo = this.g_UserInfo;
    UserInfo.OrderRefresh1 = false;
    this.setG_UserInfo(UserInfo);
    this.OrderPage = [1, 1, 1];
    this.$set(this.loadState, 0, true  )
    this.$set(this.List, 0, [])
    this.getList(1, 1);

    /*if (this.g_UserInfo.OrderRefresh1 == true) {

    }*/

  },

  deactivated(){
    this.closePop()
  },

  methods: {
    //  订单列表页，在点击订单的时候把订单编号保存起来
    ...mapMutations([
      'setG_PayOrder', 'setG_UserInfo',
    ]),

    refresh(type) {

      // this.refreshing = true;

      this.loadMsg[type - 1] = '';

      this.loadState[type - 1] = true;


      this.$set(this.List, type - 1, [])
      
      // this.List[type - 1] = [];
      // this.List.splice(999, 1, 0)


      this.getList(type, 1)

      console.log(type)
      console.log(this.List[type - 1])

    },

    //跳转到支付页 - 保存下订单号
    goPayMoney(OrderId, TotalPrice, startDate) {

      // 保存订单
      var Order = this.g_PayOrder;
      Order.TypeId = 0
      Order.OrderId = OrderId;
      Order.Money = TotalPrice;
      Order.Date = startDate;
      this.setG_PayOrder(Order);

      var params = new this.URLSearchParam();
      params.append('cardNo', this.g_UserInfo.Card_no)
      this.$http.post(api.loginState(), params.toParam()).then((res) => {
        console.log(res)
        if (res.Result) {
          this.$router.push({ path: '/payOrder/payType' });
        }
        else {
          this.showToast('登录已过期')
          this.$http.post(api.LogOff()).then((res) => { });
          this.$store.dispatch('clearUser');
          setTimeout(() => { this.$router.push({ path: '/user/login' }); }, 1200)
        }
      })
    },

    //跳转到支付页 - 保存下订单号
    // goDetail( OrderId , Money , startDate , TypeName ) {
    goDetail(OrderId, Money, TypeName) {

      // 保存订单
      var Order = this.g_PayOrder;
      Order.OrderId = OrderId;
      Order.Money = Money;
      // Order.Date = startDate;
      Order.TypeName = TypeName;
      this.setG_PayOrder(Order);
      this.$router.push({ path: '/order/OrderDetails' });
    },

    getList(type, page) {

      var params = new this.URLSearchParam();
      params.append('orderType', type);
      params.append('pageIndex', page);
      params.append('pageSize', 10);


      this.$http.post(api.getOrderList(), params.toParam()).then((res) => {
        if (res.Result) {
          this.List[type - 1] = this.List[type - 1].concat(res.Data);

          this.List[type - 1].forEach(function (element) {
            var time1 = parseInt(element.Arrivedate.substring(6, 19));
            var date1 = new Date(time1);
            var time2 = parseInt(element.Departuredate.substring(6, 19));
            var date2 = new Date(time2);

            if (date2 - date1 <= 14400000) {
              element.IsRelax = true
            }
            else {
              element.IsRelax = false
            }
          }, this);


          if (res.Data.length == 10) {
            this.loadMsg[type - 1] = '上拉加载更多';
          }
          else {
            this.loadMsg[type - 1] = '没有更多记录';
          }

          this.$set(this.loadState, type - 1, false)
        }
        else {
          //调用弹出层
          this.showToast(res.Message)
        }
      })
    },

    // 下拉刷新数据
    loadPage(type) {

    var innerHeight = window.innerHeight;
    //高度+视窗+提前量>滚动条移动距离
    if (window.scrollY + innerHeight + 200  > window.document.body.scrollHeight) {

        if (this.loadMsg[type - 1] == '上拉加载更多') {
          // this.loadState[ type-1 ] = true;
          // this.loadMsg[ type-1 ] = '加载中';

          this.$set(this.loadState, type - 1, true)
          this.$set(this.loadMsg, type - 1, '加载中')
        }
      }
    },


    loadEnd(type) {
      if (this.loadMsg[type - 1] == '加载中') {
        this.$set(this.loadMsg, type - 1, '加载中...')
        this.getList(type, ++this.OrderPage[type - 1]);
      }
    },

    hideToast() {
      this.toast = false
      if (this.toastTimer) clearTimeout(this.toastTimer)
    },
    // 弹出层  end
    // 弹出标签 选择是否

    CancelOrder(ParentResvNo) {

      this.ParentResvNo = ParentResvNo;

      this.Cancel_Delete = 'cancel';

      // this.openPop('最晚的取消时间提前1天，如未在规定时间内取消，酒店将收取全款20%的会议室预订占用费')

      // this.openPop('<div>该订单已使用的K币、代金券、储值金额将在24小时内返还至您的账户</div>'+
      // "<div style='height: 0.15rem;'></div>"+
      // '<div>已支付的金额将返还原支付渠道，最迟在15个工作日到账</div>'+
      // "<div style='height: 0.15rem;'></div>"+
      // '<div>订单取消后<span style="color:red">无法恢复</span>，如有需要请重新预订</div>'
      // )

      this.openPop('取消订单openPop')



    },

    DeleteOrder(ParentResvNo) {

      this.ParentResvNo = ParentResvNo;

      this.Cancel_Delete = 'delete';

      this.openPop('确定删除订单吗？')
    },

    closeYES() {
      //  选项关闭
      this.closePop()
      var params = new this.URLSearchParam();
      params.append('parentNo', this.ParentResvNo);
      // params.append('phoneNo', this.ParentResvNo);  只有非协议订单用户才会有第二个参数

      var tmpRoute = api.CancelResv();

      if (this.Cancel_Delete == 'delete')
        tmpRoute = api.DeleteResv();

      this.$http.post(tmpRoute, params.toParam()).then((res) => {
        console.log(res);
        if (res.Result) {
          this.showToast(res.Data)

          if (this.Cancel_Delete == 'delete')
            this.toastTimer = setTimeout(() => { this.refresh(2); }, 1200)

          if (this.Cancel_Delete == 'cancel')
            this.toastTimer = setTimeout(() => {
              this.refresh(1); this.refresh(3);

              var UserInfo = this.g_UserInfo;
              UserInfo.OrderRefresh2 = true;
              this.setG_UserInfo(UserInfo);

            }, 1200)

        }
        else {
          this.showToast(res.Message)
        }

      })
    },

    closeNO() {
      //  拒绝取消订单
      this.closePop()
    },
    // END 弹出标签 选择是否

    goback() {
      javascript: history.go(-1);
    },

    //三个分页
    handleTabChange(val) {
      this.activeTab = val;



      if (this.activeTab == 'tab2' && this.g_UserInfo.OrderRefresh2 == true) {

        var UserInfo = this.g_UserInfo;
        UserInfo.OrderRefresh2 = false;
        this.setG_UserInfo(UserInfo);

        this.List[1] = [];
        this.getList(2, 1);

      }

      if (this.activeTab == 'tab3' && this.g_UserInfo.OrderRefresh3 == true) {

        var UserInfo = this.g_UserInfo;
        UserInfo.OrderRefresh3 = false;
        this.setG_UserInfo(UserInfo);

        this.List[2] = [];
        this.getList(3, 1);

      }

    },

    closePop(){
      this.popDisplay = false
    },
    openPop(msg,onlyOk){
      //是否仅仅显示确定按钮
      if(onlyOk){
        this.popOnlyOk = onlyOk
      }
      else{
        this.popOnlyOk = false
      }
      if(msg){
        this.popMsg = msg  
      }
      this.popDisplay = true
    },
    // 弹出层
    showToast(TellUser) {
      if(TellUser){
        this.TellUser = TellUser
      }
      this.toast = true
      if (this.toastTimer) clearTimeout(this.toastTimer)
      this.toastTimer = setTimeout(() => { this.toast = false }, 1000)
      if (this.TellUser =='未登录'){
        this.$store.dispatch('clearUser');
        this.toastTimer = setTimeout(() => { this.$router.push({ path: '/user/login' }); }, 1800)
      }
    },
    hideToast() {
      this.toast = false
      if (this.toastTimer) clearTimeout(this.toastTimer)
    },
    goHome(){
      this.$router.push({ path: '/home/index' });
    }
  },

}
</script>




// paper模块
<style lang="less" scoped>
@import "../../assets/theme.less";
.demo-paper {
  // 横向显示
  /*display: inline-block;*/
  margin: 8px;
  text-align: center;
  margin-top: 10px;
}

.green {
  color: @primaryColor ;
  border: 1px solid @primaryColor ;
}

.pageContent {
  max-width: 480px;
  margin-left: auto;
  margin-right: auto;

  color: @textColor; // 顶部标签变换
  .header {
    width: 100%
  }
  .mu-tabs {
    // 背景色
    background-color: #fff;
  } // 未选中时候的颜色
  .mu-tab-link {
    color: #999999;
    font-weight: bold;
  } //  选中  分页的
  .mu-tab-active {
    color: @primaryColor;
    font-weight: bold;
  } // END 顶部标签变换
  .Orange {
    color: @primaryOrange ;
  }
  .Black {
    color: @primaryBlack ;
  }
  .Grey {
    color: @textColor;
  }
}
</style>





// WEBPACK FOOTER //
// index.vue?016084cc